import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import { mapGetters } from 'vuex';
import { rqtPostTradeFixList, rqtPostTradeEquityList } from '@/services/cms/customer';
export default {
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      active: 1,
      searchForm: {
        customerId: '',
        flag: 'undue'
      },
      equitySearchForm: {
        customerId: '',
        flag: 'undue'
      }
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  created() {
    this.searchForm.customerId = this.user.customerId;
    this.equitySearchForm.customerId = this.user.customerId;
  },
  methods: {
    rqtPostTradeFixList,
    rqtPostTradeEquityList
  }
};